import { useQueryLoader } from "react-relay"
import { graphql } from "relay-runtime"
import {
  useAgentPlanningsQuery,
  useAgentPlanningsQuery$data,
} from "@/modules/admin/agent-plannings/services/__generated__/useAgentPlanningsQuery.graphql"
import { ExtractNode } from "@/modules/patients/types/ExtractNode"

const agentPlanningsQuery = graphql`
  query useAgentPlanningsQuery {
    doctors {
      edges {
        node {
          id
          userName
          shifts {
            actualPerformance
            actualTime
            date
            shiftTypes
            slotId
          }
        }
      }
    }
  }
`

const useAgentPlanningsQueryLoader = () => {
  return useQueryLoader<useAgentPlanningsQuery>(agentPlanningsQuery)
}

export { agentPlanningsQuery, useAgentPlanningsQueryLoader }
export type AgentPlanningsQueryResult = ExtractNode<useAgentPlanningsQuery$data["doctors"]>
